<div class="default-panel receipt-remember">
  <div class="text-bold font-lg mb-1" [translate]="'receipt.attention'">Husk!</div>
  <ng-content></ng-content>
</div>
